import User from "@/schedule/entities/user";
import ScheduleCell from "../../../ui/schedule/presenters/schedule-cell";
import ScheduleCalendar from "@/schedule/entities/schedule-calendar";
import divideHours from "@/helpers/divideHours";
import { areIntervalsOverlapping } from "date-fns";
import _ from "lodash";

export default class Schedule {
  user: User;
  cells: ScheduleCell[];

  public constructor(calendar: ScheduleCalendar, projectId?: number) {
    this.user = calendar.user;
    this.cells = _.flatMap(calendar.days, d => {
      return divideHours(d.date, 2).map(period => {
        return new ScheduleCell(
          {
            ...d,
            events: d.events.filter(e => areIntervalsOverlapping(e, period))
          },
          projectId
        );
      });
    });
  }
}
